import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { AgreementHeader } from "../../models/agreement.model";
import { AgreementRepository } from "../../repositories/agreement.repository";

export interface UpdatePETCUseCaseParam {
  agreementId: number;
  agreementHeader: AgreementHeader;
}

export class UpdatePETCUseCase
  implements UseCase<UpdatePETCUseCaseParam, boolean>
{
  constructor(private repo: AgreementRepository) {}
  execute(param: UpdatePETCUseCaseParam): Observable<boolean> {
    return this.repo.updatePETC({
      id: param.agreementId,
      customer: param.agreementHeader.customer,
      dateEnd: param.agreementHeader.endDate.format("YYYY-MM-DD"),
      dateStart: param.agreementHeader.startDate.format("YYYY-MM-DD"),
      externalSource: param.agreementHeader.clm.externalSource,
      name: param.agreementHeader.name!,
      pepresourceId: param.agreementHeader.projectEngineer.id,
      winProbability: param.agreementHeader.winProbability / 10,
      contractId: param.agreementHeader.contractId,
      workloadId: param.agreementHeader.workloadId,
      proposalId: param.agreementHeader.proposalId,
    });
  }
}

const updatePETCUseCaseFactory = (repo: AgreementRepository) =>
  new UpdatePETCUseCase(repo);

export const updatePETCUseCaseProvider: Provider = {
  provide: UpdatePETCUseCase,
  useFactory: updatePETCUseCaseFactory,
  deps: [AgreementRepository],
};
